__webpack_require__.p = "/kendo-jquery-ui/documentation/";